import { useEffect, useRef } from 'react';
import { cx } from './util';

// §2.6 Popover: raised body with shadow-pop, anchored under its trigger. Closes on outside click and Escape,
// returning focus to the trigger. trigger: render prop receiving { open, toggle, ref, props }.
export default function Popover({ open, onOpenChange, trigger, align = 'start', children, label }) {
  const root = useRef(null);
  const triggerRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onDown = e => { if (!root.current?.contains(e.target)) onOpenChange(false); };
    const onKey = e => { if (e.key === 'Escape') { onOpenChange(false); triggerRef.current?.focus(); } };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open, onOpenChange]);
  return (
    <span className="ui ui-pop-anchor" ref={root}>
      {trigger({ open, toggle: () => onOpenChange(!open), ref: triggerRef, props: { 'aria-expanded': open, 'aria-haspopup': 'true' } })}
      {open && <div className={cx('ui-pop', `ui-pop--${align}`)} role="dialog" aria-label={label}>{children}</div>}
    </span>
  );
}
